<template>
	<div>
		<img
			v-bind:id="'thumbnail'+dir"
			class="thumbnail"
			:alt="dir"
			v-on:click="imageClick"
		/>
		<p v-if="vesselpic_id!=undefined" class="subtext">{{vesselpic_id}}</p>
		<div v-bind:id="'myModal'+dir" class="modal" v-on:click="close">
			<img v-bind:id="'img'+dir" class="modal-content"/>
		</div>
	</div>
</template>

<script>
import api from '@/api'
import router from '@/router/index'
export default {
    props: {
		dir: String,
		vesselpic_id: String,
		pageid:Number,
    },
	data() {
		return {

		}
	},
	mounted () {
		let stateCheck = setInterval(() => {
			if (document.getElementById("thumbnail"+this.dir)!=null) {
				clearInterval(stateCheck);
				this.setVesselpic();
			}
		}, 100);
	},
	methods:{
		async setVesselpic(){
			console.log(this.vesselpic_id)
			if(this.vesselpic_id!=''&&this.vesselpic_id!=NaN&&this.vesselpic_id!=undefined){
				api.getVesselpic(
	                {
						data:{
							filename:this.dir
						}
	                }
	            ).then((res) => {
					var embed = document.getElementById("thumbnail"+this.dir);
					var modal = document.getElementById("img"+this.dir);
					embed.src="data:image/png;base64, "+res.data;
					modal.src="data:image/png;base64, "+res.data;
		        });
			}
		},
		async imageClick(){
			var modal = document.getElementById("myModal"+this.dir);

			modal.style.display = "block";
            this.$emit('input',  this.id);
		},
		async close(){
			var modal = document.getElementById("myModal"+this.dir);
			modal.style.display = "none";
		},
	},
	watch:{
		dir(current, old){
			var modalParent = document.getElementById("myModal"+old);
			modalParent.id = "myModal"+current
			var modal = document.getElementById("img"+old);
			modal.id = "img"+current
			var embed = document.getElementById("thumbnail"+old);
			embed.id = "thumbnail"+current
			this.setVesselpic();
		},
	},
}
</script>

<style scoped>
.subtext{
	font-size: 12px;
	font-weight: normal;
	display:flex;
	flex-wrap: wrap;
	justify-content:left;
}

.thumbnail{
	max-width:100%;
	max-height:100%;
	border: 1px solid #ddd;
	border-radius: 4px;
	padding: 5px;
	cursor: pointer;
	transition-duration: 0.4s;
}
.thumbnail:hover {opacity: 0.7;}

.modal {
	display: absolute;
	position: fixed;
	z-index: 1;
	padding-top: 100px;
	left: 0;
	top: 0;
	height:100%;
	overflow:auto;
	background-color: rgba(0,0,0,0.9);
}

.modal-content {
	margin: auto;
	max-height:90%;
	max-width:90%;
	display: block;
	object-fit:contain;
	background-color: rgba(0,0,0,0);
	animation:zoom 0.1s;
}

@keyframes zoom {
	from {transform:scale(0.5)}
	to {transform:scale(1)}
}
</style>



// WEBPACK FOOTER //
// src/layouts/vesselpic.vue